export default __webpack_public_path__ + "static/media/murdoch5.87da1a22.png";